import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Mail, Phone, CalendarDays, Building2 } from "lucide-react";
import { api, formatApiError } from "@/lib/auth";

const fmtDate = (iso) => new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });

const AdminLeads = () => {
  const [leads, setLeads] = useState(null);

  const load = () => api.get("/admin/leads").then((r) => setLeads(r.data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    try {
      await api.delete(`/admin/leads/${id}`);
      setLeads((ls) => ls.filter((l) => l.id !== id));
      toast.success("Lead removido.");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div data-testid="admin-leads-page">
      <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-brand">Leads</p>
      <h1 className="mt-2 font-serif text-2xl text-[#F4F4F6] sm:text-3xl">
        {leads ? `${leads.length} ${leads.length === 1 ? "contato recebido" : "contatos recebidos"}` : "Carregando..."}
      </h1>

      <div className="mt-8 grid gap-4 lg:grid-cols-2">
        {leads?.map((l) => (
          <article key={l.id} data-testid={`admin-lead-${l.id}`} className="border border-white/10 bg-coal p-6">
            <div className="flex items-start justify-between gap-4">
              <div>
                <span className={`px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.2em] ${l.tipo === "visita" ? "bg-sun text-obsidian" : "bg-brand text-white"}`}>
                  {l.tipo === "visita" ? "Visita" : "Contato"}
                </span>
                <p className="mt-3 font-serif text-xl text-[#F4F4F6]">{l.nome}</p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.15em] text-stone-500">{fmtDate(l.criado_em)}</p>
              </div>
              <button onClick={() => remove(l.id)} data-testid={`admin-lead-delete-${l.id}`} aria-label="Remover" className="flex h-9 w-9 shrink-0 items-center justify-center border border-white/10 text-stone-400 transition-colors hover:border-brand hover:text-brand">
                <Trash2 size={14} />
              </button>
            </div>
            <div className="mt-5 space-y-2 text-sm text-stone-300">
              <a href={`mailto:${l.email}`} className="flex items-center gap-2 hover:text-brand"><Mail size={13} className="text-brand" /> {l.email}</a>
              {l.telefone && (
                <a href={`https://wa.me/55${l.telefone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand">
                  <Phone size={13} className="text-brand" /> {l.telefone}
                </a>
              )}
              {l.imovel_titulo && <p className="flex items-center gap-2"><Building2 size={13} className="text-brand" /> {l.imovel_titulo}</p>}
              {l.data_visita && <p className="flex items-center gap-2"><CalendarDays size={13} className="text-brand" /> {l.data_visita}</p>}
            </div>
            {l.mensagem && <p className="mt-4 border-t border-white/10 pt-4 text-sm font-light leading-relaxed text-stone-400">{l.mensagem}</p>}
          </article>
        ))}
        {leads?.length === 0 && (
          <p className="border border-dashed border-white/15 px-6 py-16 text-center text-stone-500 lg:col-span-2">Nenhum contato recebido ainda.</p>
        )}
      </div>
    </div>
  );
};

export default AdminLeads;
